export const playNotificationSound = () => {
  const audio = new Audio("/browserNotification.wav");
  audio
    .play()
    .catch((error) =>
      console.error("Error playing notification sound:", error)
    );
};
